import React from 'react'

import PropTypes from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function RatingIndicator({ rating, handleClick = NOOP, isActive = false }) {
  const ratingColor = rating < 4 ? 'red'
    : rating > 7 ? 'green'
      : 'orange'

  const activeClassName = isActive ? null : 'rating-indicator--dynamic'

  return (
    <span
      className={`indicator rating-indicator rating-indicator--${ratingColor} ${activeClassName}`}
      onClick={() => handleClick(rating)}
    >{rating}
    </span>
  )
}

RatingIndicator.propTypes = {
  rating: PropTypes.number.isRequired,
  handleClick: PropTypes.func,
  isActive: PropTypes.bool,
}

export default RatingIndicator
